export const paginatorVariants = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
    LOAD_MORE: 'load_more'
};
